import Card from './Card'
import style from '../../styles/components/story-collection/story-collection'

const FeaturedCard = ({ story, layout, type }) => (
  <>
    <div className={`card-container ${layout} tablet-fill`}>
      <Card cardType={type} story={story} />
    </div>
    <style jsx>{style}</style>
  </>
)

export default FeaturedCard
